// Tiny WebAudio blips — ported from the prototype (blip/ding). No assets.

let ac: AudioContext | null = null;

function ctx(): AudioContext | null {
  if (!ac) {
    try {
      const Ctor =
        window.AudioContext ||
        (window as unknown as { webkitAudioContext?: typeof AudioContext })
          .webkitAudioContext;
      if (Ctor) ac = new Ctor();
    } catch {
      ac = null;
    }
  }
  return ac;
}

function blip(freq: number, dur: number, delay: number): void {
  const a = ctx();
  if (!a) return;
  const o = a.createOscillator();
  const g = a.createGain();
  o.type = "sine";
  o.frequency.value = freq;
  g.gain.setValueAtTime(0.12, a.currentTime + delay);
  g.gain.exponentialRampToValueAtTime(0.001, a.currentTime + delay + dur);
  o.connect(g);
  g.connect(a.destination);
  o.start(a.currentTime + delay);
  o.stop(a.currentTime + delay + dur);
}

/** Two-tone chime on completion. */
export function ding(): void {
  blip(660, 0.12, 0);
  blip(990, 0.18, 0.07);
}

/** Soft single blip on add. */
export function pip(): void {
  blip(520, 0.08, 0);
}
